import React from 'react'
import AnalyticsIcon from '@mui/icons-material/Analytics';
import StorefrontIcon from '@mui/icons-material/Storefront';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';

const MenuItems = [
    {
        "item_id" : 0,
        "menu_name": "Dashboard",
        "menu_icon": <AnalyticsIcon/>,
        "menu_route": "/"
    },
    {
        "item_id" : 1,
        "menu_name": "Market ",
        "menu_icon": <StorefrontIcon/>,
        "menu_route": "/marketSurveillance"
    },
    {
        "item_id" : 2,
        "menu_name": "Hospital Surveillance",
        "menu_icon": <LocalHospitalIcon/>,
        "menu_route": "/hospitalSurveillance"
    }
]

export const getMenuItems = () => {
    return MenuItems;
} 
